<template lang="pug">
  v-layout
    v-btn(
      flat
      :disabled="currentIndex <= 0"
      v-if="!isSubmitting"
      @click="handleClickPrev"
      data-cy="button-prev-stepper"
    ) Prev
    v-btn.primary(
      v-if="currentIndex < items.length - 1 || hasSubmit === 'false'"
      :disabled="!isValid || currentIndex >= items.length - 1"
      @click="handleClickNext"
      data-cy="button-next-stepper"
    ) Next
    v-btn.primary(
      v-else
      :disabled="!isValid || submitDisabled"
      @click="handleClickPrimary"
      :loading="isSubmitting"
      data-cy="submit-button"
    ) {{ buttonType.text }}
</template>
<script>

export default {
  data() {
    return {
      currentIndex: -1,
    };
  },

  props: {
    /**
     * Set based on if any input in the create flow is valid or not. If it is not,
     * the next button will be disabled.
     */
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      required: false,
    },
    /**
     * @prop [Required] [Array] items
     * The array of items given
     * Item can be one of 'Object' | 'Number' | 'String'
     * e.g. [{ key: 0, name: 'lion' }, { key: 1, name: 'desk' }]
     */
    items: Array,
    /**
     * One of 'submit' or 'update'.
     * Changes the callback function as well
     */
    buttonType: {
      type: Object,
      default: { key: 'submit', text: 'Submit' },
    },
    /**
     * @prop [Optional] [String] objectKey
     * If given, this means that items is and array of objects
     * This determines the value being returned. Otherwise, return the whole item
     * e.g. 'type'
     */
    objectKey: String,
    /**
     * @prop [Optional]
     * Controls whether the last button should be Submit instead of Next.
     */
    hasSubmit: {
      type: String,
      default: 'false',
    },
    /**
     * @prop [Optional]
     * If hasSubmit is true, sets the disabled condition for that button
     */
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * @prop [Required] [String | Number | Object] value
     * The current selection that the user is currently in.
     * e.g. 'template-type'
     */
    value: String || Number || Object,
  },

  mounted() {
    this.calculateIndex(this.items, this.objectKey, this.value);
  },

  watch: {
    items: {
      handler(value) {
        this.calculateIndex(value, this.objectKey, this.value);
      },
      deep: true,
    },
    value(value) {
      this.calculateIndex(this.items, this.objectKey, value);
    },
  },

  methods: {
    calculateIndex(items, objectKey, value) {
      this.currentIndex =
        objectKey ?
          items.findIndex(item => item[objectKey] === value) :
          items.findIndex(item => item === value);
    },
    handleClickPrev() {
      if (this.currentIndex > 0) {
        if (this.objectKey) {
          this.$emit('input', this.items[--this.currentIndex][this.objectKey]);
        } else {
          this.$emit('input', this.items[--this.currentIndex]);
        }
      }
    },
    handleClickNext() {
      if (this.currentIndex < this.items.length - 1) {
        if (this.objectKey) {
          this.$emit('input', this.items[++this.currentIndex][this.objectKey]);
        } else {
          this.$emit('input', this.items[++this.currentIndex]);
        }
      }
    },
    handleClickPrimary() {
      if (this.buttonType.key === 'submit') {
        this.$emit('submit-clicked');
      } else if (this.buttonType.key === 'update') {
        this.$emit('update-clicked');
      }
    },
  },

};
</script>
